import {Injectable} from "@angular/core";
import {Http} from "@angular/http";

@Injectable()
export class Helper {
   constructor() {}

}


// WEBPACK FOOTER //
// ./src/app/_helpers/helper.ts